import React from 'react';
import { Helmet } from 'react-helmet-async';

const Layout = ({ children, title, description, canonical ,keywords}) => {
  const defaultTitle = "Ehankki – Käytetyt huonekalut ja sisustusratkaisut";
  const defaultDescription =
    "Ehankki tarjoaa käytettyjä sohvia, tv-tasoja,sänky mattoja ja muita laadukkaita sisustustuotteita helposti verkosta.";
  const defaultCanonical = "https://ehankki.fi/";
  const defaultKeywords = "käytetty sohva, käytetyt huonekalut, tv-taso, matto, laadukas sohva, kierrätyshuonekalut, Helsinki kalusteet";

  return (
    <>
      <Helmet>
        <title>{title || defaultTitle}</title>
        <meta name="keywords" content={keywords || defaultKeywords} />
        <meta name="description" content={description || defaultDescription} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={title || defaultTitle} />
        <meta property="og:description" content={description || defaultDescription} />
        <meta property="og:image" content="https://ehankki.fi/logo.png" />
        <meta property="og:url" content={canonical || defaultCanonical} />
        <meta property="og:site_name" content="Ehankki" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title || defaultTitle} />
        <meta name="twitter:description" content={description || defaultDescription} />
        <meta name="twitter:image" content="https://ehankki.fi/logo.png" />
        <link rel="canonical" href={canonical || defaultCanonical} />
        <meta name="robots" content="index, follow" />

           {/* LocalBusiness Structured Data */}
          <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            name: "Ehankki",
            image: "https://ehankki.fi/logo_son.jpg",
            "@id": "https://ehankki.fi",
            url: "https://ehankki.fi",
            telephone: "+358 41 312 4969",
            address: {
              "@type": "PostalAddress",
              streetAddress: "Niittyläntie 3",
              addressLocality: "Helsinki",
              postalCode: "00620",
              addressCountry: "FI"
            },
            openingHours: "Mo-Fr 10:00-17:00",
            sameAs: [
              "https://www.facebook.com/profile.php?id=61564073464686"
            ]
          })}
        </script>
      </Helmet>
      {children}
    </>
  );
};

export default Layout;
